import React from 'react';

type Props = {
    text: string;
    highlight: string;
};

const HighlightText: React.FC<Props> = ({ text, highlight }) => {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

    return (
        <span className='highlight-text'>
            {parts.map((part, i) => (
                <span
                    key={i}
                    className={
                        part.toLowerCase() === highlight.toLowerCase()
                            ? 'highlighted'
                            : undefined
                    }
                >
                    {part}
                </span>
            ))}
        </span>
    );
};

export default HighlightText;
